// Mirrors iOS SoundManager — same alert file, same enable/disable prefs,
// vibration standing in for haptics on Android.
export class SoundService {
  private static audio: HTMLAudioElement | null = null;

  static isSoundEnabled(): boolean {
    return localStorage.getItem('sound_enabled') !== '0';
  }

  static setSoundEnabled(enabled: boolean): void {
    localStorage.setItem('sound_enabled', enabled ? '1' : '0');
  }

  private static getAudio(): HTMLAudioElement {
    if (!this.audio) {
      this.audio = new Audio(`${process.env.PUBLIC_URL || ''}/sounds/alert.mp3`);
      this.audio.preload = 'auto';
    }
    return this.audio;
  }

  private static play(): void {
    if (!this.isSoundEnabled()) return;
    const audio = this.getAudio();
    audio.currentTime = 0;
    // Browsers block audio before the first user gesture — fail quietly
    audio.play().catch(() => {});
  }

  private static vibrate(pattern: number | number[]): void {
    if (localStorage.getItem('haptic_enabled') === '0') return;
    if ('vibrate' in navigator) navigator.vibrate(pattern);
  }

  // iOS: playProximityAlertFeedback — alert sound + warning haptic
  static playProximityAlert(): void {
    this.play();
    this.vibrate([200, 100, 200]);
  }

  // iOS: playPinDroppedFeedback — alert sound + medium haptic
  static playPinDropped(): void {
    this.play();
    this.vibrate(100);
  }

  // iOS: playNotificationSound — alert sound + light haptic
  static playNotification(): void {
    this.play();
    this.vibrate(50);
  }
}
